import { Chip, MoreButton } from '@design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';
import { adjustTextColor } from '../utils/adjustTextColor';
import { hexToRgb } from '../utils/hexToRgb';

const links = [
  {
    label: translations.DOCUMENT_PAGES.NEW_COLOR,
    value: 'color',
  },
  {
    label: translations.COMMON.EDIT,
    value: 'edit',
  },
  {
    label: translations.COMMON.DELETE,
    value: 'delete',
  },
];

export type SignerProps = {
  name: string;
  email: string;
  index: string;
  stage: any;
  color: string;
  canLifeProof?: boolean;
  validate_rfc?: boolean;
  identity_verification?: boolean;
  user_coordinates?: boolean;
  autograph?: boolean;
  advanced?: boolean;
  typed?: boolean;
  hasRfcValidationEnabled?: boolean;
  handleDeleteSigner: (stage: any, index: any) => void;
  handleEditSigner: (stage: any, index: any) => void;
  handleColorChange: (stage: any, index: any) => void;
};

export const Signer: React.FC<SignerProps> = ({
  name,
  email,
  index,
  stage,
  color = '',
  identity_verification,
  user_coordinates,
  validate_rfc,
  autograph: autographProp,
  advanced,
  typed,
  hasRfcValidationEnabled,
  handleDeleteSigner,
  handleEditSigner,
  handleColorChange,
}) => {
  const { t } = useTranslation();
  const onClick = (value, stage, index) => {
    if (value === 'delete' && handleDeleteSigner)
      handleDeleteSigner(stage, index);
    if (value === 'edit' && handleEditSigner) handleEditSigner(stage, index);
    if (value === 'color' && handleColorChange) handleColorChange(stage, index);
  };
  const autograph = autographProp || typed;

  const rgb = hexToRgb(color);
  const colorAdjusted = adjustTextColor(`rgb(${rgb?.r}, ${rgb?.g}, ${rgb?.b})`);

  const getSignatures = () => {
    if (autograph && advanced) {
      return `${t(translations.COMMON.ADVANCED)} y ${t(
        translations.COMMON.AUTOGRAPH,
      )}`;
    }

    if (autograph) {
      return `${t(translations.COMMON.AUTOGRAPH)}`;
    }

    if (advanced) {
      return `${t(translations.COMMON.ADVANCED)}`;
    }
  };

  return (
    <div>
      <div className="mb-4 flex text-left text-paragraph font-bold text-gray-500">
        <span className="relative top-2 ">
          {t(translations.COMMON.SIGNER)} {index + 1}
        </span>
        <MoreButton
          className="relative top-2 ml-auto"
          items={links as any}
          onClick={(value) => onClick(value, stage, index)}
        />
      </div>
      <div>
        <div className="mb-2 inline-flex flex-col">
          <Chip color={color} size="sm">
            {name}
          </Chip>
        </div>
        <p>
          {t(translations.COMMON.EMAIL)}:{' '}
          <span className=" font-bold">{email}</span>
        </p>
        <p>
          {t(translations.COMMON.SIGNATURE_TYPE)}{' '}
          <span className=" font-bold">{getSignatures()}</span>
        </p>
        <p>
          {t(translations.COMMON.ASK_LIFE_PROOF)}{' '}
          <span className=" font-bold">
            {' '}
            {identity_verification
              ? t(translations.COMMON.YES)
              : t(translations.COMMON.NO)}
          </span>
        </p>
        <p>
          {t(translations.COMMON.GEOLOCATION)}:{' '}
          <span className=" font-bold">
            {' '}
            {user_coordinates
              ? t(translations.COMMON.REQUIRED)
              : t(translations.COMMON.OPTIONAL)}
          </span>
        </p>
        {hasRfcValidationEnabled === true && (
          <p>
            {t(translations.COMMON.VERIFY_RFC_VS_FEA)}:{' '}
            <span className=" font-bold">
              {' '}
              {validate_rfc
                ? t(translations.COMMON.YES)
                : t(translations.COMMON.NO)}
            </span>
          </p>
        )}
      </div>
      <hr className="my-4 border border-dashed border-gray-100 md:min-w-full" />
    </div>
  );
};
